// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aijVd","right":"styles_right__2Alnx"};